var __webpack_error__ = new Error();
module.exports = new Promise((resolve, reject) => {
	if(typeof fed_sharedlib !== "undefined") return resolve();
	__webpack_require__.l("https://g1.itc.cn/msfe-wlogin-prod/000000000002/dist/remoteEntry.js", (event) => {
		if(typeof fed_sharedlib !== "undefined") return resolve();
		var errorType = event && (event.type === 'load' ? 'missing' : event.type);
		var realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		reject(__webpack_error__);
	}, "fed_sharedlib");
}).then(() => (fed_sharedlib));